import request from '@/utils/request';

export function getMyPlanList(params, silentRequest) {
  return request({
    url: '/MySchedule/explore',
    params,
    silentRequest,
  });
}

export function getMyPlanDetail(id, silentRequest) {
  return request({
    url: '/MySchedule/detail',
    params: {
      id,
    },
    silentRequest,
  });
}

export function changeCurrentPlan(id) {
  return request({
    url: '/MySchedule/changeCurrent',
    method: 'POST',
    data: {
      id,
    },
  });
}

export function getFinishPlanTaskShare(id) {
  return request({
    url: '/MySchedule/finishTaskShare',
    params: {
      id,
    },
  });
}

export function getLearningSurveyInfo() {
  return request({
    url: '/Schedule/surveyInfo',
    silentRequest: true,
  });
}

export function getLearningSurveyResult(params) {
  return request({
    url: '/Schedule/surveyResult',
    params,
  });
}

export function getPlanDetail(id) {
  return request({
    url: '/Schedule/detail',
    params: {
      id,
    },
  });
}

export function getPlanSchedule() {
  return request({
    url: '/Schedule/index',
  });
}


export function setProgramPlayEndLog(programId) {
  return request({
    url: 'MySchedule/programPlayEndLog',
    params: {
      id: programId,
    },
  });
}
